/**
 * JavaScript client for [Onvio Profile Services API](https://demo.onvio.us/swagger/).
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { ProfileManager, profileManager } from './profile-manager.js';
export { getUserProfileV1, updateProfileLanguage } from './profile-services.js';
export { profileNgProvider } from './ng-injector.js';
registerLibrary({
    name: '@blue/security-profile',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "2.1.0",
});
